import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { IRetracementSettingsRow, IRetracementSettingsRowsSet, RetracementSettings } from 'src/app/Models/RetracementSettings';
import { CookiesService } from 'src/app/Services/cookieService';
import { CountsData, DgHubClientService, RetracementSetting, RetracementSettingsRequest, RetracementTypes } from 'src/app/Services/dg-hub-client.service';
import { DGDrawingServiceGlobal, DrawingService } from 'src/app/Services/DrawingService';
import { settingChanges } from 'src/components/retracement-settings/retracement-settings.component';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-eventsTabs',
  templateUrl: './Events.component.html',
  styleUrls: ['./Events.component.scss']
})
export class EventsComponent implements OnInit {

  constructor(
  //  public dialogRef: MatDialogRef<EventsComponent>,
    public dgCLientService: DgHubClientService,
    public drawingService: DrawingService,
    private cookieService: CookiesService,
    public sanitizer: DomSanitizer
  ) { }

  public displayedColumns: string[] = ['Strike', 'Last Size', 'Time', 'PNL','PRICE', 'COST'];
  public dataSource: CountsData[]=[];
  ngOnInit() {


    var initialMode = this.drawingService.settingsService.getAdvanceState();
    var eventsDataTomorrow = Object.assign([], this.drawingService.signalService.eventsTomorrowDayData);
    var eventsData = Object.assign([], this.drawingService.signalService.eventsData);
    this.renderData(initialMode, eventsData.reverse(), eventsDataTomorrow.reverse());


      this.drawingService.eventsInitiated.subscribe(()=>{


          var initialMode = this.drawingService.settingsService.getAdvanceState();
          var eventsDataTomorrow = Object.assign([], this.drawingService.signalService.eventsTomorrowDayData);
          var eventsData = Object.assign([], this.drawingService.signalService.eventsData);
          this.renderData(initialMode, eventsData.reverse(), eventsDataTomorrow.reverse());
        })



    this.drawingService.signalService.previusDayCountsData.subscribe((k)=>{
      console.log("eventsDataTomorrow - renderProcess")
        var eventsDataTomorrow = Object.assign([], this.drawingService.signalService.eventsTomorrowDayData);
        var eventsData = Object.assign([], this.drawingService.signalService.eventsData);
        this.renderData(k, eventsData.reverse(), eventsDataTomorrow.reverse());
      })

    this.drawingService.signalService.newCountsData.subscribe((l)=>{
      //console.log(l);
      
      var eventsDataTomorrow = Object.assign([], this.drawingService.signalService.eventsTomorrowDayData);
      var eventsData = Object.assign([], this.drawingService.signalService.eventsData);
      this.renderData(this.drawingService.signalService.currentDataMode, eventsData.reverse(), eventsDataTomorrow.reverse());
     // var html = this.prepareHtml([l]);
      //jQuery("#eventsPreview").prepend(html);
    })
    
  }
public currentDataMode:number = 0;
public renderData(mode:number, eventsData, eventsDataTomorrow)
{
  switch(mode)
  {
    case 0: 
      this.dataSource = eventsData;
      var html = this.prepareHtml(this.dataSource);
      jQuery("#eventsPreview").html("");
      jQuery("#eventsPreview").append(html);
    break;
    case 1: 
      this.dataSource = eventsDataTomorrow;
      var html = this.prepareHtml(this.dataSource);
      jQuery("#eventsPreview").html("");
      jQuery("#eventsPreview").append(html);
    break;
  }

}


public prepareHtml(dataSource: CountsData[])
{
  var html="";
  dataSource.forEach((data)=>{

  html+=`
  <tr>
      <td style="text-align:center; ">
        <b ${this.isRedText(data.symbol)?` style="color:red"`:` style="color:green"`}>${data.strike} </b>
      </td>
      <td style="text-align:center;;padding-left:3px;padding-right:3px;color:#fff"> ${data.lastSize}</td>
      <td style="text-align:center ">
        <span ${this.getTime(data.dateTime).includes('AM')?`style="color:rgb(0, 247, 255)"`:`style="color:rgb(234, 0, 255)"`}>${ this.getTimeS(data.dateTime)}</span>
      </td>
    </tr>
    <tr>
      <td style="text-align:center "> 
        <span *ngIf="!data.itm" ${data.itm?` ${data.itm==null?``:`style="color:red"`}`:`style="color:green"`}>${data.points} </span>
      </td>
      <td style="text-align:center;padding-left:3px;padding-right:3px; color:orange"> <span>${data.tradeInfoPricePointsFixed}</span></td>
      <td style="text-align:center "><div>${data.costStrTable}</div></td>
    </tr>
    <tr style="display:none">
    <td colspan="3" style="color:#fff">${this.getTimeAll(data.dateTime)}</td>
    </tr>
    `;
  })
  return html;
}












public getTimeAll(val)
{
  return moment(val).format("YYYY-MM-DD HH:mm")
}

  public getTime(val)
  {
    return moment(val).format("hh:mm A")
  }

  public getTimeS(val)
  {
    return moment(val).format("hh:mm")
  }

  public isRedText(val)
  {
    if(val!=undefined)
    {
      return val.includes(" P")
    }
    return false;
  }
}
